import { ComponentNameEnum, BaseStepperPxPercentSliderFieldConfig } from '@/types';

const getImageBorderRadiusFieldConfig = (defaultValue = 0): BaseStepperPxPercentSliderFieldConfig => ({
  componentName: ComponentNameEnum.STEPPER_PX_PERCENT_SLIDER,
  options: {
    px: {
      min: 0,
      max: 999,
      step: 1,
      defaultValue,
      isDefaultUnitSelected: true,
    },
  },
});

export default getImageBorderRadiusFieldConfig;
